import { Position } from "../../defines/types"
import { Pigment } from "./pigment"

export class PigmentDrop extends Pigment {
  private _amount: number

  constructor(color: string, position: Position, amount: number = 1) {
    super(color, position, false)
    this._amount = amount
  }

  get amount(): number {
    return this._amount
  }
}
